import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const resetPasswordAPI = async ({subsidiaryId, email}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/client/reset-password`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify({
            email_address: email,
        }),
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    if (response.status === 204) {
        return {};
    }

    return await response.json();
};

export {resetPasswordAPI};
